(() => {
  if (window.EscStorePages) {
    window.EscStorePages.init(document);
    return;
  }
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const normalizeDescription = root => {
    const source = root.querySelector('[data-description-source]');
    if (!source) return;
    source.querySelectorAll('*').forEach(element => {
      element.removeAttribute('style');
      element.removeAttribute('class');
    });
  };
  const initProduct = root => {
    if (root.dataset.storeInitialized) return;
    root.dataset.storeInitialized = 'true';
    normalizeDescription(root);
    const track = root.querySelector('[data-gallery-track]');
    const media = [...root.querySelectorAll('[data-media-id]')];
    const thumbnails = [...root.querySelectorAll('[data-gallery-thumb]')];
    const markActive = index => thumbnails.forEach((thumbnail, itemIndex) => {
      if (itemIndex === index) thumbnail.setAttribute('aria-current', 'true');
      else thumbnail.removeAttribute('aria-current');
    });
    const selectMedia = (id, instant = false) => {
      const index = media.findIndex(item => item.dataset.mediaId === String(id));
      if (!track || index < 0) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: instant || reducedMotion() ? 'instant' : 'smooth' });
      markActive(index);
    };
    thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', event => {
      event.preventDefault();
      selectMedia(thumbnail.dataset.galleryThumb);
    }));
    if (track) {
      let frame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => markActive(Math.round(track.scrollLeft / track.clientWidth)));
        media.forEach(item => item.querySelectorAll('video').forEach(video => {
          if (Math.abs(item.offsetLeft - track.scrollLeft) > track.clientWidth / 2) video.pause();
        }));
      }, { passive: true });
      if (track.dataset.initialMedia) selectMedia(track.dataset.initialMedia, true);
    }
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      if (!quantity) return;
      const current = Number(quantity.value) || 1;
      quantity.value = Math.max(Number(quantity.min) || 1, current + Number(button.dataset.quantityStep));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    const variantSelect = root.querySelector('[data-variant-select]');
    if (variantSelect) variantSelect.addEventListener('change', () => {
      const variant = variantSelect.selectedOptions[0];
      if (!variant) return;
      const available = variant.dataset.available === 'true';
      root.querySelector('[data-variant-price]').textContent = variant.dataset.price;
      const compare = root.querySelector('[data-variant-compare]');
      compare.textContent = variant.dataset.compare;
      compare.hidden = variant.dataset.sale !== 'true';
      root.querySelector('[data-buy-button]').disabled = !available;
      root.querySelector('[data-buy-label]').textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
      root.querySelector('[data-stock-status]').classList.toggle('is-unavailable', !available);
      root.querySelector('[data-stock-label]').textContent = available ? root.dataset.stockLabel : root.dataset.soldLabel;
      if (variant.dataset.media) selectMedia(variant.dataset.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState({}, '', url);
    });
  };
  const initCatalog = root => {
    if (root.dataset.storeInitialized) return;
    root.dataset.storeInitialized = 'true';
    const url = new URL(window.location.href);
    const brand = (url.searchParams.get('brand') || '').toLowerCase();
    const cards = [...root.querySelectorAll('[data-product-brand]')];
    const tabs = [...root.querySelectorAll('[data-brand-tab]')];
    if (['ninebot', 'xiaomi', 'navee', 'bosch'].includes(brand)) {
      cards.forEach(card => card.hidden = card.dataset.productBrand !== brand);
      tabs.forEach(tab => {
        if (tab.dataset.brandTab === brand) tab.setAttribute('aria-current', 'page');
        else tab.removeAttribute('aria-current');
      });
      const found = cards.filter(card => !card.hidden).length;
      const count = root.querySelector('[data-product-count]');
      if (count && root.dataset.countLabel) count.textContent = root.dataset.countLabel.replace('__COUNT__', found);
      const empty = root.querySelector('[data-brand-empty]');
      if (empty) empty.hidden = found > 0;
      root.querySelectorAll('.sp-native-filters a').forEach(link => {
        const filterUrl = new URL(link.href);
        filterUrl.searchParams.set('brand', brand);
        link.href = filterUrl.toString();
      });
    }
    const sort = root.querySelector('[data-collection-sort]');
    if (sort) sort.addEventListener('change', () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('sort_by', sort.value);
      nextUrl.searchParams.delete('page');
      window.location.assign(nextUrl.toString());
    });
    document.addEventListener('click', event => {
      root.querySelectorAll('.sp-filter[open]').forEach(filter => {
        if (!filter.contains(event.target)) filter.removeAttribute('open');
      });
    });
  };
  const init = scope => {
    scope.querySelectorAll('[data-store-product]').forEach(initProduct);
    scope.querySelectorAll('[data-store-catalog]').forEach(initCatalog);
  };
  window.EscStorePages = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
